import { IElement } from '@studio/domain/creativeset/element';
import { NodeKind } from '@studio/domain/nodes';
import { AssetReference, AssetReferenceValue } from '@studio/domain/element-asset';
import { FeededReference, FeededReferenceValue } from '@studio/domain/feed';

export function getAssetReferenceTypeOfElement(element: IElement): AssetReferenceValue {
    switch (element.type) {
        case NodeKind.Image:
            return AssetReference.Image;
        case NodeKind.Video:
            return AssetReference.Video;
        case NodeKind.Widget:
            return AssetReference.Widget;
    }

    throw new Error(`Can't get asset reference name from an element that does not have any assets.`);
}

export function getFeedReferenceTypeOfElement(element: IElement): FeededReferenceValue {
    switch (element.type) {
        case NodeKind.Image:
            return FeededReference.Image;
        case NodeKind.Video:
            return FeededReference.Video;
    }

    throw new Error(`Can't get feed reference name from an element that does not have any assets.`);
}

export function remapCreativeAssetUrls(creativeData: string, destination: string): string {
    const publishFolder = '/published';
    const parts = destination.split(publishFolder);

    return creativeData.replaceAll(`${parts[0]}/images`, destination);
}
